import {CONFIG} from "../../config";

export class ConfigService {
    public static async init(): Promise<ConfigService> {
        if (!ConfigService.initialized) {
            ConfigService.setConfig();
            return ConfigService;
        } else {
            console.log('Already initialized ConfigService!');
        }
    }
    
    private static initialized = false;
    
    private static config: Config;
    
    public static getConfig(): Config {
        return ConfigService.config;
    }
    
    public static get(key: keyof Config) {
        if (ConfigService.config.hasOwnProperty(key)) {
            return ConfigService.config[key];
        }
        return null;
    }
    
    private static setConfig() {
        ConfigService.config = CONFIG;
    }

    public static fuels = [
        { name: 'super', label: 'general.fuel_types.super' },
        { name: 'diesel', label: 'general.fuel_types.diesel'},
        { name: 'ultimateDiesel', label: 'general.fuel_types.ultimate_diesel'},
        { name: 'ultimateSuper', label: 'general.fuel_types.ultimate_super'},
        //{ name: 'autogas', label: 'general.fuel_types.autogas'},
        { name: 'adblue', label: 'general.fuel_types.adblue'},
        { name: 'hvo', label: 'general.fuel_types.hvo'}
    ];
}

export interface Config {
    API_URL: string;
    PAGE_SIZE: number;
    ENVIRONMENT: string;
    DEVIATION_THRESHOLD: number;
    BUGSNAG_KEY: string;
}
